<template>
    <!-- <tr class="selected"> -->
    <tr :class="{'selected': isSelected , 'red_txt': isCanceled }" @click="action_SelectReservationHistory()" @dblclick="action_DoubleClickCell">
        <td>
            <button @click="action_ShowReservationChangeHistory($event)">
                <v-icon small>mdi-history</v-icon>
            </button>
            {{  getReservationDateString }}
        </td>
        <td><span class="ellipsis" :title="getGroupString">{{ getGroupString }}</span></td>
        <td><span class="ellipsis" :title="getColumnString">{{ getColumnString }}</span></td>
        <td><span class="ellipsis" :title="getProgramString">{{ getProgramString }}</span></td>
        <td>
            <span class="ellipsis" :title="getNoteString">
                <button @click="copyMemoText($event)"><v-icon small>mdi-content-copy</v-icon></button>
                {{ getNoteString }}
            </span>
        </td>
    </tr>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import { mapActions } from 'vuex'
import moment from '../../../../../../../../../util/MPMoment'
import { closeAlertPopup } from '../../../../../sheet-alert'
import { closePopup } from '../../../../../sheet-overlays'
import { setSelectedReservation } from '../../../../../reservation-selection'
import { setSelectedDate } from '../../../../../sheet-axis'
import { handleRefresh } from '../../../../../sheet-refresh'
import { editGuardState, invokeGuard } from '../../popup-edit-guard'
export default {
    props: {
        reservation: Object,
        selectedReservationID: String
    },
    data() {
        return {
            editGuard: editGuardState,
        }
    },
    watch: {

    },
    mounted() {

    },
    computed: {
        getReservationDateString: function() {
            return moment(this.reservation.startedAt).format(this.$t('common.date_format_YYYY_MM_DD_HH_mm'))
        },
        getGroupString: function() {
            return this.reservation.groupTitle?? '-s'
        },
        getColumnString: function() {
            return this.reservation.columnTitle ?? '-'
        },
        getProgramString: function() {
            return this.reservation.programTitle ?? '-'
        },
        getNoteString: function() {
            return this.reservation.note ?? '-'
        },
        isSelected: function() {
            return this.selectedReservationID == this.reservation._id
        },
        isCanceled: function() {
            return this.reservation.isCanceled ?? false
        },

    },
    methods: {
        ...mapActions(['setToast']),
        action_SelectReservationHistory() {
            let selectedID = undefined
            if (this.reservation._id != this.selectedReservationID) {
                selectedID = this.reservation._id
            }
            this.action_HideReservationChangeHistory()
            this.$emit('setSelectedReservationID', selectedID)
        },

        action_ShowReservationChangeHistory(event) {
            event.stopPropagation()
            if (this.reservation._id != this.selectedReservationID) {
                this.action_SelectReservationHistory()
            }
            this.$emit('showReservationChangeHistory')
        },

        action_HideReservationChangeHistory() {
            this.$emit('hideReservationChangeHistory')
        },

        async action_DoubleClickCell() {
            if (this.editGuard.isEditBasicInfo) {
                let result = await invokeGuard('AlertEditUserBasicInfo')
                if (result == false) { 
                    closeAlertPopup()
                    return 
                }
            }
            else if (this.editGuard.isUserNoteChanged) {
                await invokeGuard('AlertEditUserNote')
            }
            
            let date = moment(this.reservation.startedAt).startOf('days')
            setSelectedDate(date)
            setSelectedReservation(deepCopy(this.reservation))
            handleRefresh()
            closePopup()
        },

        async copyMemoText(event) {
            event.stopPropagation()
            try {
                let memo = this.reservation.note ?? ''
                await navigator.clipboard.writeText(memo)
                this.showClipboardCopySuccessToast()
            } catch (err) {
                console.log("clipboard copy error :", err)
            }
        },

        showClipboardCopySuccessToast() {
            this.setToast({
                isShow: true,
                text: '예약메모가 복사되었습니다.'
            })
        }
    }

}
</script>